import {
    faCalendarAlt,
    faDownload,
    faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { Dispatch, SetStateAction, useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ColumnDescription, SelectRowProps } from "react-bootstrap-table-next";
import { useFormContext } from "react-hook-form";
import { useUserInfor } from "../../../../Context/User";
import {
    AlterarDataVencimentoBoletosController,
    GerarLinkBoletoSegundaViaSiengeController,
} from "../../../../Controllers/Cobranca/Boleto/BoletoController";
import {
    BaixarBoletoPDFESolutionController,
    GetBoletoPDFController,
} from "../../../../Controllers/Cobranca/ParcelasAbertas/ParcelasAbertasController";
import { IParcelaBoletos } from "../../../../Interfaces/Cobranca/ParcelasAbertas/ParcelasAbertas";
import { IDadosERP } from "../../../../Interfaces/Geral/ERP/ERPInterface";
import { replaceClass } from "../../../../Tools/Classtools";
import { formatMoneyReais } from "../../../../Tools/FormatTools";
import { downloadLink } from "../../../../Tools/ProcessingTools";
import { AlertConfirm } from "../../../../Tools/SweetAlerts";
import { MoneyReaisFieldMask } from "../../../../Validations/InputMasks";
import UnForm from "../../../Form";
import Table from "../../../Table";
import jsPDF from "jspdf";
import { useAtendimentoPage } from "../../../../Context/AtendimentoPage";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { Spinner } from "../../../Loding/SpinnerPadrao";
import saveAs from "file-saver";

interface ITableParcelasBoletosProps {
    lstParcelas: Array<IParcelaBoletos>;
    lstParcelasMarcadas: Array<IParcelaBoletos>;
    setLstParcelasMarcadas: Dispatch<SetStateAction<Array<IParcelaBoletos>>>;
    DT_CALCULO: string;
    unidade: string;
    empreendimento: string;
    loading: boolean;
    showResiduo: boolean;
    erp: IDadosERP;
    //setBoletoParaEmail: (boleto: IBoletoDeParcela) => void
}

export default function TableParcelasBoletos(
    props: ITableParcelasBoletosProps
) {
    const { OrgInfor } = useUserInfor();

    const { Atendimento } = useAtendimentoPage();

    const { showResiduo } = props;

    const { setValue } = useFormContext();

    const siengeMode = OrgInfor.COD_ERP_INTEGRACAO === "SIENGE";
    const totvsMode = OrgInfor.COD_ERP_INTEGRACAO === "TOTVS";

    const selectRowProp: SelectRowProps<IParcelaBoletos> = {
        mode: "checkbox",
        selectionRenderer: ({
            checked,
            disabled,
            rowIndex,
        }: {
            checked: boolean;
            disabled: boolean;
            mode: string;
            rowIndex: number;
            rowKey: string;
        }) => {
            const isDisabled = disabled;
            //const isDisabled = disabled || row?.FL_SPC_SERASA;
            return isDisabled ? (
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip id={`tooltip-top-checkbox-${rowIndex}`}>
                            Parcelas enviadas ao SPC não podem ser renegociadas.
                        </Tooltip>
                    }
                >
                    <input
                        type="checkbox"
                        checked={checked}
                        disabled={isDisabled}
                        onChange={isDisabled ? undefined : () => {}}
                        style={{
                            cursor: isDisabled ? "not-allowed" : "pointer",
                        }}
                    />
                </OverlayTrigger>
            ) : (
                <input
                    type="checkbox"
                    checked={checked}
                    disabled={isDisabled}
                    onChange={isDisabled ? undefined : () => {}}
                />
            );
        },
        onSelect: (row, isSelect) => {
            //if (row.FL_SPC_SERASA) return;
            row.FL_MARC = isSelect;

            props.setLstParcelasMarcadas((prevSelecionados) => {
                if (isSelect) {
                    return [...(prevSelecionados ?? []), row];
                } else {
                    return (
                        prevSelecionados?.filter(
                            (selec) =>
                                selec.idParcelaCapys !== row.idParcelaCapys
                        ) || []
                    );
                }
            });
        },
        onSelectAll: (isSelect, rows: Array<IParcelaBoletos>) => {
            rows.forEach((row) => {
                //if (!row.FL_SPC_SERASA) {
                row.FL_MARC = isSelect;
                //}
            });
            const lstParcelasMarcadas =
                props.lstParcelas?.filter((p) => p.FL_MARC) ?? [];
            props.setLstParcelasMarcadas(isSelect ? lstParcelasMarcadas : []);
        },
        selected: props.lstParcelasMarcadas.map(
            (selecionados) => selecionados.idParcelaCapys
        ),
    };

    function GetLinkBoletoSienge(parcela: IParcelaBoletos) {
        GerarLinkBoletoSegundaViaSiengeController({
            ...props.erp,
            installmentId: parcela.NumParc_Prc,
        }).then((res) => {
            downloadLink(res.urlReport, {
                target: "__blank",
            });
        });
    }

    const {
        execute: BaixarBoletoPDFESolution,
        loading: BaixarBoletoPDFESolutionLoading,
    } = useAsyncCallback(BaixarBoletoPDFESolutionController);

    // effect necessárion para toda vez que a lista de parcelas atualizar,
    // manter o valor das parcelas para geração do boleto atualizada
    useEffect(() => {
        props.lstParcelas.forEach((p) => {
            setValue(
                `parcelas.${p.NumParc_Prc}.VL_PARCELA_DESEJADO`,
                formatMoneyReais(p.ValorReaj)
            );
        });
    }, [props.lstParcelas, setValue]);

    const eSolutionMode =
        OrgInfor.COD_ERP_INTEGRACAO === "ESOLUTION" ||
        OrgInfor.COD_ERP_INTEGRACAO === "ESOLUTION_LIVA";

    //#region table
    const columns: Array<ColumnDescription> = [
        {
            dataField: "NumParc_Prc",
            text: "Parcelas",
            formatter: row,
            headerClasses: "d-none",
        },
    ];

    const columnsTableView: Array<ColumnDescription<IParcelaBoletos>> = [
        {
            dataField: "Tipo_Prc",
            text: "Parcela",
            classes: "p-3 ws-nowrap",
            formatter: (c, row) => {
                const data = new Date(row.Data_Prc);
                return (
                    <span
                        className={
                            data.getTime() < Date.now() ? "text-danger" : ""
                        }
                    >
                        {c}{" "}
                        {row.Descricao_par && (
                            <span> - {row.Descricao_par} </span>
                        )}{" "}
                        - {row.NumParc_Prc}
                    </span>
                );
            },
            headerAlign: "center",
        },
        {
            dataField: "Data_Prc",
            text: "Data de Vencimento",
            formatter: (c) => {
                const data = new Date(c);
                return (
                    <span
                        className={
                            data.getTime() < Date.now() ? "text-danger" : ""
                        }
                    >
                        {new Date(c).toLocaleDateString()}
                    </span>
                );
            },
            classes: "p-3 ws-nowrap",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "ValorReaj",
            text: "Valor Reajus.",
            formatter: (c, row) => {
                const data = new Date(row.Data_Prc);
                return (
                    <span
                        className={
                            data.getTime() < Date.now() ? "text-danger" : ""
                        }
                    >
                        {formatMoneyReais(c)}
                    </span>
                );
            },
            classes: "p-3 ws-nowrap",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "Valor_Prc",
            text: "Valor Principal",
            formatter: (c, row) => {
                const data = new Date(row.Data_Prc);
                return (
                    <span
                        className={
                            data.getTime() < Date.now() ? "text-danger" : ""
                        }
                    >
                        {formatMoneyReais(c)}
                    </span>
                );
            },
            classes: "p-3 ws-nowrap",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "vlrCorrecao",
            text: "Valor de Correção",
            formatter: (c, row) => {
                const data = new Date(row.Data_Prc);
                return (
                    <span
                        className={
                            data.getTime() < Date.now() ? "text-danger" : ""
                        }
                    >
                        {formatMoneyReais(c)}
                    </span>
                );
            },
            classes: "p-3 ws-nowrap",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "ValorMulta",
            text: "Multa",
            formatter: (c, row) => {
                const data = new Date(row.Data_Prc);
                return (
                    <span
                        className={
                            data.getTime() < Date.now() ? "text-danger" : ""
                        }
                    >
                        {formatMoneyReais(c)}
                    </span>
                );
            },
            classes: "p-3 ws-nowrap",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "vlrJurosAtraso",
            text: "Juros de Atraso",
            formatter: (c, row) => {
                const data = new Date(row.Data_Prc);
                return (
                    <span
                        className={
                            data.getTime() < Date.now() ? "text-danger" : ""
                        }
                    >
                        {formatMoneyReais(c)}
                    </span>
                );
            },
            classes: "p-3 ws-nowrap",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "vlrJurosParcela",
            text: "Juros da Parcela",
            formatter: (c, row) => {
                const data = new Date(row.Data_Prc);
                return (
                    <span
                        className={
                            data.getTime() < Date.now() ? "text-danger" : ""
                        }
                    >
                        {formatMoneyReais(c)}
                    </span>
                );
            },
            classes: "p-3 ws-nowrap",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "vlrResiduo",
            text: "Valor Resíduo",
            formatter: (c, row) => {
                const data = new Date(row.Data_Prc);
                return (
                    <span
                        className={
                            data.getTime() < Date.now() ? "text-danger" : ""
                        }
                    >
                        {formatMoneyReais(
                            (row.vlrResiduo ?? 0) +
                                (row.vlrMultaResiduo ?? 0) +
                                (row.vlrJurosAtraResiduo ?? 0)
                        )}
                    </span>
                );
            },
            classes: "p-3 ws-nowrap",
            align: "center",
            headerAlign: "center",
            hidden: !showResiduo,
        },
        {
            dataField: "parcela.VL_PARCELA_DESEJADO",
            text: `${totvsMode ? "Valor a Pagar" : ""}`,
            formatter: (c: string, row) => {
                return totvsMode ? (
                    <div className="d-flex flex-row justify-content-center align-items-center">
                        <UnForm.Input
                            max={row.ValorReaj}
                            min={1}
                            onChange={MoneyReaisFieldMask}
                            registerOptions={{
                                setValueAs: (v: string) =>
                                    Number(MoneyReaisFieldMask.unMask(v)),
                                // validate: (v) => {
                                //     const value = Number(
                                //         MoneyReaisFieldMask.unMask(v)
                                //     );
                                //     if (
                                //         value > row.ValorReaj &&
                                //         lstParcelasMarcadasRef.current.some(
                                //             (p) => p === row
                                //         )
                                //     )
                                //         return "Valor maior que parcela";
                                //     else return true;
                                // },
                            }}
                            name={`parcelas.${row.NumParc_Prc}.VL_PARCELA_DESEJADO`}
                            style={{ width: 120 }}
                            defaultValue={formatMoneyReais(row.ValorReaj)}
                        />
                    </div>
                ) : (
                    ""
                );
            },

            classes: "p-3 ws-nowrap",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "Boleto.DataVenc_bol",
            text: "Vencimento (Boleto)",
            formatter: (c: string, row) => {
                const data = new Date(row.Data_Prc);
                return c && row.Boleto ? (
                    <div className="d-flex flex-row justify-content-center align-items-center">
                        <input
                            className={
                                data.getTime() < Date.now()
                                    ? "text-danger form-control"
                                    : "form-control"
                            }
                            disabled={totvsMode}
                            type="date"
                            onBlur={(e) => {
                                if (c !== e.target.value) {
                                    c = e.target.value;
                                }
                            }}
                            defaultValue={c.substring(0, 10)}
                        />

                        {!totvsMode && (
                            <div>
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="tooltip-disabled">
                                            {
                                                "Alterar data de vencimento do boleto"
                                            }
                                        </Tooltip>
                                    }
                                >
                                    <button
                                        className="btn btn-primary ml-2 toClick btn-download-boleto"
                                        data-toggle="tooltip"
                                        onClick={() => {
                                            AlertConfirm(
                                                "Tem certeza que deseja alterar a data de vencimento do boleto?"
                                            ).then((result) => {
                                                if (result.isConfirmed) {
                                                    if (row.Boleto) {
                                                        replaceClass(
                                                            `button-download-${row.Boleto.SeuNum_Bol}-${row.Boleto.Banco_Bol}`,
                                                            "toClick",
                                                            "loading"
                                                        );
                                                        AlterarDataVencimentoBoletosController(
                                                            row.Boleto
                                                                .SeuNum_Rea,
                                                            row.Boleto
                                                                .Banco_Rea,
                                                            row.Boleto
                                                                .Empresa_rea,
                                                            c,
                                                            props.DT_CALCULO
                                                        )
                                                            .then(() => {
                                                                replaceClass(
                                                                    `button-download-${row.Boleto?.SeuNum_Bol}-${row.Boleto?.Banco_Bol}`,
                                                                    "loading",
                                                                    "toClick"
                                                                );
                                                            })
                                                            .catch(() => {
                                                                replaceClass(
                                                                    `button-download-${row.Boleto?.SeuNum_Bol}-${row.Boleto?.Banco_Bol}`,
                                                                    "loading",
                                                                    "toClick"
                                                                );
                                                            });
                                                    }
                                                }
                                            });
                                        }}
                                    >
                                        <div className="toClick-component">
                                            <FontAwesomeIcon
                                                icon={faCalendarAlt}
                                                size="sm"
                                            />
                                        </div>
                                        <div className="loading-component">
                                            <div
                                                className="spinner-border spinner-border-sm text-light"
                                                role="status"
                                            >
                                                <span className="sr-only">
                                                    Carregando...
                                                </span>
                                            </div>
                                        </div>
                                    </button>
                                </OverlayTrigger>
                            </div>
                        )}
                    </div>
                ) : (
                    ""
                );
            },
            classes: "p-3 ws-nowrap",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "",
            text: "",
            isDummyField: true,
            formatter: (c, row) => (
                <>
                    {eSolutionMode && (
                        <button
                            className="btn btn-success ml-2 toClick btn-download-boleto"
                            disabled={BaixarBoletoPDFESolutionLoading}
                            onClick={() => {
                                if (row.CODIGOBARRA) {
                                    BaixarBoletoPDFESolution(
                                        Atendimento?.NR_CPF ?? "",
                                        [row.CODIGOBARRA]
                                    ).then((res) => {
                                        if (res) {
                                            const pdfContent = atob(res);

                                            const arrayBuffer = new ArrayBuffer(
                                                pdfContent.length
                                            );
                                            const uint8Array = new Uint8Array(
                                                arrayBuffer
                                            );
                                            for (
                                                let i = 0;
                                                i < pdfContent.length;
                                                i++
                                            ) {
                                                uint8Array[i] =
                                                    pdfContent.charCodeAt(i);
                                            }

                                            const blob = new Blob(
                                                [arrayBuffer],
                                                {
                                                    type: "application/pdf",
                                                }
                                            );

                                            saveAs(
                                                blob,
                                                `Boleto - ${row.Tipo_Prc} - ${row.NumParc_Prc}`
                                            );
                                        }
                                    });
                                }
                            }}
                        >
                            {BaixarBoletoPDFESolutionLoading ? (
                                <Spinner size="sm" />
                            ) : (
                                <FontAwesomeIcon icon={faDownload} size="sm" />
                            )}
                        </button>
                    )}
                    {(row.Boleto && !totvsMode) ||
                    (siengeMode && row.FL_BOLETO_SIENGE && !totvsMode) ? (
                        <>
                            {siengeMode ? (
                                <>
                                    <button
                                        className="btn btn-success ml-2"
                                        onClick={() => GetLinkBoletoSienge(row)}
                                    >
                                        <FontAwesomeIcon
                                            icon={faDownload}
                                            size="sm"
                                        />
                                    </button>
                                    <button
                                        className="btn btn-primary ml-2"
                                        onClick={() =>
                                            props.setLstParcelasMarcadas(
                                                (lstParcelasRequest) =>
                                                    lstParcelasRequest[0] ===
                                                    row
                                                        ? []
                                                        : [row]
                                            )
                                        }
                                    >
                                        <FontAwesomeIcon
                                            icon={faEnvelope}
                                            size="sm"
                                        />
                                    </button>
                                </>
                            ) : (
                                <>
                                    <button
                                        className="btn btn-success ml-2 toClick btn-download-boleto"
                                        id={`button-download-${
                                            row.Boleto!.SeuNum_Bol
                                        }-${row.Boleto!.Banco_Bol}`}
                                        onClick={() => {
                                            if (row.Boleto) {
                                                const downloadLink: HTMLAnchorElement | null =
                                                    document.querySelector(
                                                        `#link-download-${row.Boleto.SeuNum_Bol}-${row.Boleto.Banco_Bol}`
                                                    );
                                                // se o link de download ja tiver href setado, ele irá apenas baixar o arquivo novamente
                                                if (
                                                    downloadLink &&
                                                    (downloadLink.href.search(
                                                        /^data:application\/pdf;base64/
                                                    ) ||
                                                        downloadLink.href.search(
                                                            /^data:image\/jpeg;base64/
                                                        )) < 0
                                                ) {
                                                    //desabilita butão e troca ícone por loading
                                                    replaceClass(
                                                        `button-download-${row.Boleto.SeuNum_Bol}-${row.Boleto.Banco_Bol}`,
                                                        "toClick",
                                                        "loading"
                                                    );
                                                    const button: HTMLButtonElement | null =
                                                        document.querySelector(
                                                            `#button-download-${row.Boleto.SeuNum_Bol}-${row.Boleto.Banco_Bol}`
                                                        );
                                                    if (button)
                                                        button.disabled = true;

                                                    GetBoletoPDFController({
                                                        ...row.Boleto,
                                                        nrCpfCliente:
                                                            Atendimento?.NR_CPF,
                                                    }).then((res) => {
                                                        if (row.Boleto) {
                                                            var doc =
                                                                new jsPDF();
                                                            if (downloadLink) {
                                                                //muda o link de download e força um click para baixar o arquivo
                                                                if (
                                                                    OrgInfor.COD_ERP_INTEGRACAO ===
                                                                    "INFORMAKON"
                                                                ) {
                                                                    downloadLink.href = `data:image/jpeg;base64,${res}`;
                                                                    doc.addImage(
                                                                        downloadLink.href,
                                                                        "JPEG",
                                                                        15,
                                                                        40,
                                                                        180,
                                                                        180
                                                                    );
                                                                    doc.save(
                                                                        "Boleto"
                                                                    );
                                                                } else {
                                                                    downloadLink.href = `data:application/pdf;base64,${res}`;
                                                                    downloadLink.click();
                                                                }

                                                                replaceClass(
                                                                    `button-download-${row.Boleto.SeuNum_Bol}-${row.Boleto.Banco_Bol}`,
                                                                    "loading",
                                                                    "toClick"
                                                                );
                                                                if (button)
                                                                    button.disabled =
                                                                        false;
                                                            }
                                                        }
                                                    });
                                                } else if (downloadLink)
                                                    downloadLink.click();
                                            }
                                        }}
                                    >
                                        <div className="toClick-component">
                                            <FontAwesomeIcon
                                                icon={faDownload}
                                                size="sm"
                                            />
                                        </div>
                                        <div className="loading-component">
                                            <div
                                                className="spinner-border spinner-border-sm text-light"
                                                role="status"
                                            >
                                                <span className="sr-only">
                                                    Carregando...
                                                </span>
                                            </div>
                                        </div>
                                    </button>
                                    <a
                                        id={`link-download-${
                                            row.Boleto!.SeuNum_Bol
                                        }-${row.Boleto!.Banco_Bol}`}
                                        href="#/"
                                        className="d-none"
                                        download={`${props.unidade}_BOLETO_${
                                            props.empreendimento
                                        }${
                                            OrgInfor.COD_ERP_INTEGRACAO ===
                                            "INFORMAKON"
                                                ? ".jpeg"
                                                : ".pdf"
                                        }`}
                                    >
                                        empty link
                                    </a>
                                </>
                            )}
                        </>
                    ) : (
                        ""
                    )}
                </>
            ),
            classes: "p-3 ws-nowrap",
            align: "center",
            headerAlign: "center",
        },
    ];

    function row(c: string, row: IParcelaBoletos) {
        const parcelaVencida = new Date(row.Data_Prc).getTime() < Date.now();
        const data = new Date(row.Data_Prc);
        return (
            <div className="w-100 ml-auto mb-2">
                <div className="w-100 p-3">
                    <div className="d-flex flex-wrap align-itens-center justify-content-between mb-2">
                        <big className="font-weight-bolder">
                            <span className="text-dark-75">
                                {row.Tipo_Prc} - {row.NumParc_Prc}
                            </span>
                        </big>
                        <div className="d-flex flex-wrap align-items-center justify-content-center g-2">
                            <div className="d-flex flex-wrap align-itens-start justify-content-center g-3">
                                <div className="d-flex flex-wrap flex-column mr-1 ">
                                    <span className="d-block font-weight-bold">
                                        Data de Competência
                                    </span>
                                    <span
                                        className={`label label-light-${
                                            parcelaVencida
                                                ? "danger"
                                                : "primary"
                                        } label-inline mr-2 my-1`}
                                    >
                                        {moment(row.Data_Prc).format("MM/yy")}
                                    </span>
                                </div>
                                <div className="d-flex flex-wrap flex-column mr-1">
                                    <span className="d-block font-weight-bold">
                                        Data Vencimento
                                    </span>
                                    <span
                                        className={`label label-light-${
                                            parcelaVencida
                                                ? "danger"
                                                : "primary"
                                        } label-inline mr-2 my-1`}
                                    >
                                        {moment(row.Data_Prc).format(
                                            "DD/MM/yy"
                                        )}
                                    </span>
                                </div>
                                {row.Boleto && !totvsMode && (
                                    <div>
                                        <span className="d-flex flex-wrap font-weight-bold align-items-center">
                                            Data vencimento Boleto
                                        </span>

                                        <input
                                            className={
                                                data.getTime() < Date.now()
                                                    ? "text-danger form-control"
                                                    : "form-control"
                                            }
                                            type="date"
                                            onBlur={(e) => {
                                                if (
                                                    row.Boleto?.DataVenc_bol &&
                                                    row.Boleto?.DataVenc_bol !==
                                                        e.target.value
                                                ) {
                                                    row.Boleto.DataVenc_bol =
                                                        e.target.value;
                                                }
                                            }}
                                            defaultValue={row.Boleto?.DataVenc_bol?.substring(
                                                0,
                                                10
                                            )}
                                        ></input>
                                    </div>
                                )}
                            </div>

                            {row.Boleto && !totvsMode && (
                                <div className="d-flex flex-wrap align-items-center justify-content-center g-4">
                                    <OverlayTrigger
                                        overlay={
                                            <Tooltip id="tooltip-disabled">
                                                {
                                                    "Alterar data de vencimento do boleto"
                                                }
                                            </Tooltip>
                                        }
                                    >
                                        <button
                                            className="btn btn-primary ml-2 toClick"
                                            data-toggle="tooltip"
                                            onClick={() => {
                                                AlertConfirm(
                                                    "Tem certeza que deseja alterar a data de vencimento do boleto ?"
                                                ).then((result) => {
                                                    if (result.isConfirmed) {
                                                        if (row.Boleto) {
                                                            replaceClass(
                                                                `button-download-${row.Boleto.SeuNum_Bol}-${row.Boleto.Banco_Bol}`,
                                                                "toClick",
                                                                "loading"
                                                            );
                                                            AlterarDataVencimentoBoletosController(
                                                                row.Boleto
                                                                    .SeuNum_Rea,
                                                                row.Boleto
                                                                    .Banco_Rea,
                                                                row.Boleto
                                                                    .Empresa_rea,
                                                                row.Boleto
                                                                    .DataVenc_bol,
                                                                props.DT_CALCULO
                                                            )
                                                                .then(() => {
                                                                    replaceClass(
                                                                        `button-download-${row.Boleto?.SeuNum_Bol}-${row.Boleto?.Banco_Bol}`,
                                                                        "loading",
                                                                        "toClick"
                                                                    );
                                                                })
                                                                .catch(() => {
                                                                    replaceClass(
                                                                        `button-download-${row.Boleto?.SeuNum_Bol}-${row.Boleto?.Banco_Bol}`,
                                                                        "loading",
                                                                        "toClick"
                                                                    );
                                                                });
                                                        }
                                                    }
                                                });
                                            }}
                                        >
                                            <div className="toClick-component">
                                                <FontAwesomeIcon
                                                    icon={faCalendarAlt}
                                                />
                                            </div>
                                            <div className="loading-component">
                                                <div
                                                    className="spinner-border spinner-border-sm text-light"
                                                    role="status"
                                                >
                                                    <span className="sr-only">
                                                        Carregando...
                                                    </span>
                                                </div>
                                            </div>
                                        </button>
                                    </OverlayTrigger>
                                    <button
                                        className="btn btn-success toClick"
                                        id={`button-download-${row.Boleto.SeuNum_Bol}-${row.Boleto.Banco_Bol}`}
                                        onClick={() => {
                                            if (row.Boleto) {
                                                const downloadLink: HTMLAnchorElement | null =
                                                    document.querySelector(
                                                        `#link-download-${row.Boleto.SeuNum_Bol}-${row.Boleto.Banco_Bol}`
                                                    );
                                                // se o link de download ja tiver href setado, ele irá apenas baixar o arquivo novamente
                                                if (
                                                    downloadLink &&
                                                    downloadLink.href.search(
                                                        /^data:application\/pdf;base64/
                                                    ) < 0
                                                ) {
                                                    //desabilita butão e troca ícone por loading
                                                    replaceClass(
                                                        `button-download-${row.Boleto.SeuNum_Bol}-${row.Boleto.Banco_Bol}`,
                                                        "toClick",
                                                        "loading"
                                                    );
                                                    const button: HTMLButtonElement | null =
                                                        document.querySelector(
                                                            `#button-download-${row.Boleto.SeuNum_Bol}-${row.Boleto.Banco_Bol}`
                                                        );
                                                    if (button)
                                                        button.disabled = true;

                                                    GetBoletoPDFController(
                                                        row.Boleto
                                                    ).then((res) => {
                                                        if (row.Boleto) {
                                                            if (downloadLink) {
                                                                if (
                                                                    OrgInfor.COD_ERP_INTEGRACAO ===
                                                                    "INFORMAKON"
                                                                ) {
                                                                    downloadLink.href = `data:image/jpeg;base64,${res}`;
                                                                } else {
                                                                    //muda o link de download e força um click para baixar o arquivo
                                                                    downloadLink.href = `data:application/pdf;base64,${res}`;
                                                                }
                                                                downloadLink.click();

                                                                replaceClass(
                                                                    `button-download-${row.Boleto.SeuNum_Bol}-${row.Boleto.Banco_Bol}`,
                                                                    "loading",
                                                                    "toClick"
                                                                );
                                                                if (button)
                                                                    button.disabled =
                                                                        false;
                                                            }
                                                        }
                                                    });
                                                } else if (downloadLink)
                                                    downloadLink.click();
                                            }
                                        }}
                                    >
                                        <div className="toClick-component">
                                            <FontAwesomeIcon
                                                icon={faDownload}
                                            />
                                        </div>
                                        <div className="loading-component">
                                            <div
                                                className="spinner-border spinner-border-sm text-light"
                                                role="status"
                                            >
                                                <span className="sr-only">
                                                    Carregando...
                                                </span>
                                            </div>
                                        </div>
                                    </button>
                                    <a
                                        id={`link-download-${row.Boleto.SeuNum_Bol}-${row.Boleto.Banco_Bol}`}
                                        href="#/"
                                        className="d-none"
                                        download={`${props.unidade}_BOLETO_${props.empreendimento}.pdf`}
                                    >
                                        link
                                    </a>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="d-flex flex-wrap justify-content-between mr-1">
                        <div className="d-flex flex-column mb-1">
                            <span className="text-dark-50 flex-root font-weight-bold">
                                Valor Reajus.
                            </span>
                            <span className="text-dark flex-root font-weight-bold">
                                {formatMoneyReais(row.ValorReaj)}
                            </span>
                        </div>
                        <div className="d-flex flex-column mb-1">
                            <span className="text-dark-50 flex-root font-weight-bold">
                                Valor Principal
                            </span>
                            <span className="text-dark flex-root font-weight-bold">
                                {formatMoneyReais(row.Valor_Prc)}
                            </span>
                        </div>
                        <div className="d-flex flex-column mb-1">
                            <span className="text-dark-50 flex-root font-weight-bold">
                                Correção
                            </span>
                            <span className="text-dark flex-root font-weight-bold">
                                {formatMoneyReais(row.vlrCorrecao)}
                            </span>
                        </div>
                        <div className="d-flex flex-column mb-1">
                            <span className="text-dark-50 flex-root font-weight-bold">
                                Multa
                            </span>
                            <span className="text-dark flex-root font-weight-bold">
                                {formatMoneyReais(row.ValorMulta)}
                            </span>
                        </div>
                        <div className="d-flex flex-column mb-1">
                            <span className="text-dark-50 flex-root font-weight-bold">
                                Juros Atraso
                            </span>
                            <span className="text-dark flex-root font-weight-bold">
                                {formatMoneyReais(row.vlrJurosAtraso)}
                            </span>
                        </div>
                        <div className="d-flex flex-column mb-1">
                            <span className="text-dark-50 flex-root font-weight-bold">
                                Juros Parcela
                            </span>
                            <span className="text-dark flex-root font-weight-bold">
                                {formatMoneyReais(row.vlrJurosParcela)}
                            </span>
                        </div>
                        {showResiduo && (
                            <div className="d-flex flex-column mb-1">
                                <span className="text-dark-50 flex-root font-weight-bold">
                                    Valor Resíduo
                                </span>
                                <span className="text-dark flex-root font-weight-bold">
                                    {formatMoneyReais(
                                        (row.vlrResiduo ?? 0) +
                                            (row.vlrMultaResiduo ?? 0) +
                                            (row.vlrJurosAtraResiduo ?? 0)
                                    )}
                                </span>
                            </div>
                        )}

                        {totvsMode && (
                            <div className="d-flex flex-column mb-1">
                                <span className="text-dark-50 flex-root font-weight-bold">
                                    Valor a Pagar
                                </span>
                                <div className="d-flex flex-row justify-content-center align-items-center">
                                    <UnForm.Input
                                        max={row.ValorReaj}
                                        min={1}
                                        onChange={MoneyReaisFieldMask}
                                        registerOptions={{
                                            setValueAs: (v: string) =>
                                                Number(
                                                    MoneyReaisFieldMask.unMask(
                                                        v
                                                    )
                                                ),
                                            // validate: (v) => {
                                            //     const value = Number(
                                            //         MoneyReaisFieldMask.unMask(
                                            //             v
                                            //         )
                                            //     );
                                            //     if (
                                            //         value > row.ValorReaj &&
                                            //         lstParcelasMarcadasRef.current.some(
                                            //             (p) => p === row
                                            //         )
                                            //     )
                                            //         return "Valor maior que parcela";
                                            //     else return true;
                                            // },
                                        }}
                                        name={`parcelas.${row.NumParc_Prc}.VL_PARCELA_DESEJADO`}
                                        style={{ width: 120 }}
                                        defaultValue={formatMoneyReais(
                                            row.ValorReaj
                                        )}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
    //#endregion

    return (
        <Table
            data={props.lstParcelas}
            columns={columns}
            keyField="idParcelaCapys"
            bordered={false}
            rowClasses="border-bottom border-gray checkbox-table"
            noDataIndication={() => (
                <div className="text-center text-muted">
                    Nenhuma Parcela Disponível
                </div>
            )}
            sizePerPage={props.lstParcelas.length}
            selectRow={siengeMode ? undefined : selectRowProp}
            loading={props.loading}
            tableView={{
                columns: columnsTableView,
            }}
            wrapperClasses="y-scroll maxHeight-300 mb-2"
            noPagination
            noSearch
        />
    );
}
